export const theme = Object.freeze({
  colors: {
    mainColor: '#00ff00',
    secondaryColor: '#006400',
    offlineColor: '#ff0000',
    backgroundColorDark: '#353535',
    backgroundColorLight: '#d3d3d3',
  },
});
